export default __webpack_public_path__ + "static/media/steps-cover-5-2.eb300393.png";